<template>
  <!-- An organization's mark: ROUND, like every avatar in the app (his call).
       The logo FILLS the circle (cover) — a contained wide logo left a thin
       strip floating in a white disc, which read as a broken image. No logo:
       the identity-coloured initials, the same derivation every org row uses. -->
  <Avatar :class="props.class" :identity="org.id">
    <AvatarImage v-if="logoUrl" :src="logoUrl" :alt="name" />
    <AvatarFallback>{{ initials }}</AvatarFallback>
  </Avatar>
</template>

<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue'
import type { components } from '@/api/schema'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { mediaUrl } from '@/lib/utils'

type Organization = components['schemas']['OrganizationResource']

const props = defineProps<{
  org: Organization
  class?: HTMLAttributes['class']
}>()

const name = computed(() => props.org.attributes.name ?? '')
// ⚠ `mediaUrl` is not optional: blobs are served by the API host, not the SPA's origin.
const logoUrl = computed(() => {
  const url = props.org.attributes.logo_url
  return url ? mediaUrl(url) : ''
})
// Two-word rule, so one org reads the same everywhere.
const initials = computed(() =>
  name.value.split(/\s+/).slice(0, 2).map(word => word[0] ?? '').join('').toUpperCase())
</script>
